module.exports = __webpack_public_path__ + "static/media/logo.a95f42a4.svg";